import { TSupportedLocales } from 'types';
import { DE_LOCALE, UK_LOCALE } from './i18n';
import { RuntimeEnvironments } from './runtimeEnvironment';

enum oneTrustCookieSources {
  STAGING_UK = 'b0b36db3-a346-479f-8d72-9e7991b0ee04-test',
  STAGING_DE = 'da072cb6-7bb2-46f3-a088-e6ec9345c358-test',
  PROD_UK = 'b0b36db3-a346-479f-8d72-9e7991b0ee04',
  PROD_DE = 'da072cb6-7bb2-46f3-a088-e6ec9345c358',
}

export function oneTrustCookies(
  environment: RuntimeEnvironments,
  locale: TSupportedLocales,
): oneTrustCookieSources {
  if (environment === 'production' && locale === UK_LOCALE) {
    return oneTrustCookieSources.PROD_UK;
  }

  if (environment === 'production' && locale === DE_LOCALE) {
    return oneTrustCookieSources.PROD_DE;
  }

  if (environment === 'staging' && locale === DE_LOCALE) {
    return oneTrustCookieSources.STAGING_DE;
  }

  return oneTrustCookieSources.STAGING_UK;
}
